import Icon from '@ant-design/icons'
import {Avatar, Button, Input, Modal} from 'antd'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {createValue} from 'components/form/utils'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useRef, useState} from 'react'
import {AiOutlineQuestion} from 'react-icons/ai'
import {IoCheckmark, IoClose} from 'react-icons/io5'
import {useToggle} from 'react-use'
import {renderSelf} from 'views/Shared'
import {API_ROOT_URL} from '../../envs/_current/config'
import preventParentEvent from '../../helpers/preventParentEvent'
import {Pure} from '../../components/Pure'
import {useDeBounceValue} from '../../views/Search/useDeBounceValue'
import {renderIf, renderIfElse} from '../../views/Shared'
import {BsCaretDownFill, BsPlusLg, BsSearch} from "react-icons/bs";
import Translate from "../../modules/local/Translate";
import {PiLink, PiLinkBreakLight, PiLinkLight} from "react-icons/pi";
import {RxKeyboard} from "react-icons/rx";
import useAsync from "../../modules/asyncCache/useAsync";
import {FaUserTie} from "react-icons/fa6";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../helpers/getLinkToDetail";
import {RiSearch2Line} from "react-icons/ri";
import LoadingBlock from "../../views/LoadingBlock";
import {useRequiredLogin} from "../../views/Server/useRequiredLogin";

const renderOptDefault = (o, i) => {
    return (
        <Translate key={i}>
            {(t) => (
                <React.Fragment>
                    <Avatar
                        size={30}
                        icon={<FaUserTie size={14} className="text-color-500"/>}
                        src={o.avatar || o.cover_photo || o.thumbnail}
                        className="flex flex-center background-200"
                    />
                    <div className="flex items-baseline flex-1 gap-1 text-sm leading-snug">
                        {renderIf(
                            o.patron_saint_name,
                            <span className="font-medium text-color-100 italic">{o.patron_saint_name}</span>
                        )}
                        <Link to={getLinkToDetail(o)} className="font-bold text-color-000">{t(o.label)}</Link>
                    </div>
                </React.Fragment>
            )}
        </Translate>
    )
}

const OptWrapperDefault = ({children, ...props}) => {
    return (
        <div
            className="px-3 py-2 border border-color-50 shadow-md hover:scale-2xs flex items-center gap-2 rounded-lg" {...props}>
            {children}
        </div>
    )
}

const buildUrlWithParams = (pathUrl, keyword) => {
    const urlObj = new URL(pathUrl, window.location.origin); // Tạo URL object
    const params = urlObj.searchParams; // Lấy các tham số hiện có

    params.set('keyword', keyword);

    urlObj.search = params.toString();

    return urlObj.pathname + '?' + params.toString(); // Trả về path + các params mới
};

const LookupResult = ({
                          cacheRequired = true,
                          type,
                          keyword,
                          createIfNotExists,
                          withAlias,
                          toggle,
                          renderOption = renderOptDefault,
                          OptionWrapper = OptWrapperDefault,
                          onFinish,
                          apiPath = null,
                          schema = null,
                          // isSelected = renderFalse,
                          selectedOption,
                          defaultDisplayValue,
                          valueType = "id"
                      }) => {
    const t = useTranslate()
    const [displayValue, setDisplayValue] = useState(defaultDisplayValue || selectedOption?.value || getTitle(selectedOption));
    const [selectedValue, setSelectedValue] = useState(selectedOption || {
        ...selectedOption,
        ...(
            valueType === "id" ? {
                label: selectedOption?.label || getTitle(selectedOption),
                value: selectedOption?.id || getId(selectedOption),
            } : {
                id: selectedOption?.value || displayValue,
            }
        )

    });

    const isSelected = ({id, value}) => {
        if (!selectedValue) return false;
        if (!!!selectedValue?.id) return false;
        return [id, value].includes(selectedValue?.id)
    }

    const path = !!apiPath
        ? buildUrlWithParams(apiPath, keyword)
        : `/lookup/${type}/gets?keyword=${keyword}`
    const {
        response,
    } = useAsync({
        ...(cacheRequired ? {cacheId: path} : {}),
        apiInfo: {
            root: API_ROOT_URL,
            path: path,
            method: 'GET',
            ...(schema ? {schema} : {}),
        },
    })

    let options = _.uniq(
        _.filter(_.get(response, 'data.data', []), function (o) {
            return o.id !== ''
        }).map((option) => ({
            ...option,
            ...(
                valueType === "id" ? {
                    label: getTitle(option),
                    value: option?.id || getId(option),
                } : {}
            )

        }))
    );

    if (selectedOption && !!selectedOption?.id) {

        const found = options.some((el) => el.id === selectedOption?.id)
        if (!found)
            options.push({
                ...selectedOption,
                label: selectedOption?.label || getTitle(selectedOption),
                value: selectedOption?.id || getId(selectedOption),
            })
        options = _.sortBy(options, obj => obj.id !== selectedOption?.id);
    }

    return (
        <div
            key={keyword}
            className="w-full pt-4 flex flex-col space-y-3">
            {!!createIfNotExists && !!(keyword && keyword.length) && (
                <div
                    className="flex border border-color-50 rounded-md background px-3 py-2"
                    key="@create new">
                    <div className="flex items-center flex-1 gap-2 text-sm truncate">
                        <BsPlusLg size={13} className="text-color-500"/>
                        <div className="flex flex-col">
                            <span className="text-color-400 italic leading-tight text-2xs">{t('keyword')}</span>
                            <span className="font-semibold text-blue-600 leading-tight">{keyword}</span>
                        </div>
                    </div>
                    <div
                        onClick={() => {
                            onFinish(createValue(type, keyword || ''))
                            toggle()
                        }}
                        style={{height: 24, padding: '0 10px', borderRadius: 5, fontSize: 12, cursor: 'pointer'}}
                        className="my-auto flex flex-center background hover:bg-primary-50 font-medium text-primary-600 hover:text-primary italic">
                        {t('use this keyword')}
                    </div>
                </div>
            )}
            <div
                style={{height: (!!withAlias && selectedOption?.id) && 300}}
                className={classNames("flex flex-col gap-3", (!!withAlias && selectedOption?.id) && 'pr-2 overflow-auto scrollBarThin')}>
                {options
                    .map((o) => (
                        <OptionWrapper key={o.value}>
                            {renderOption(o)}
                            {isSelected(o) ? (
                                <IoCheckmark
                                    size={20}
                                    className="mx-5 text-green-500"
                                />
                            ) : (
                                <button
                                    onClick={() => {
                                        if (!!!withAlias) {
                                            onFinish({
                                                target: {
                                                    ...o,
                                                    // name: type,
                                                    value: o.label || '',
                                                    id: o.value,
                                                },
                                            })
                                            toggle()
                                        } else {
                                            setDisplayValue(o.label)
                                            setSelectedValue({
                                                ...o,
                                                // name: type,
                                                value: o.label || '',
                                                id: o.value,
                                            })
                                        }
                                    }}
                                    style={{height: 22, padding: '0 10px', border: 0}}
                                    className="mx-2 flex flex-center rounded-md font-medium bg-secondary-50 hover:bg-secondary-100 text-xs text-secondary-600 leading-tight">
                                    {t('select')}
                                </button>
                            )}
                        </OptionWrapper>
                    ))}
            </div>
            {
                !!withAlias && selectedValue?.id && (
                    <div className="flex flex-col gap-3 py-3 border-t">
                        <div className="flex flex-col">
                        <span className="font-bold text-sm text-color-200 uppercase tracking-wide">
                            {t('display name')}
                        </span>
                            <span className="text-xs text-color-500 italic mb-2 leading-snug">
                            <span className="font-medium text-color-400">{`* ${t('note')} : `}</span>
                                {t('display name description')}
                        </span>
                            <div className="flex items-center gap-x-4 md:gap-x-6 mb-4">
                                <Input
                                    size="large"
                                    onChange={(e) => {
                                        setDisplayValue(e.target.value)
                                    }}
                                    value={displayValue}
                                    placeholder={t('no selected')}
                                />
                                <Button size={"large"}
                                        type="primary"
                                        onClick={() => {
                                            onFinish({
                                                target: {
                                                    ...selectedValue,
                                                    value: displayValue || selectedValue.label || ''
                                                },
                                            })
                                            toggle()
                                        }}
                                        className="button-rounded-md flex flex-center no-border px-6">
                                    {t('apply')}
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    )
}

const Lookup = ({
                    isToggle,
                    toggle,
                    withAlias,
                    createIfNotExists,
                    type,
                    title,
                    description = 'You can enter keywords in the search box below to quickly find the information you’re looking for',
                    onFinish,
                    apiPath = null,
                    selectedOption,
                    defaultDisplayValue = null,
                    ...props
                }) => {
    const t = useTranslate()
    const inputSearchRef = useRef(null);
    // State and setters for ...
    // Search term
    const [searchTerm, setSearchTerm] = useState('')
    // Debounce search term so that it only gives us latest value ...
    // ... if searchTerm has not been updated within last 500ms.
    // The goal is to only have the API call fire when user stops typing ...
    // ... so that we aren't hitting our API rapidly.
    const debouncedSearchTerm = useDeBounceValue(searchTerm, 300)

    useEffect(() => {

        let timeout = setTimeout(() => {
            if (inputSearchRef.current) {
                inputSearchRef.current.focus();
            }
        }, 300)

        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [])

    return (
        <Modal
            width={620}
            className="custom-modal"
            maskClosable={false}
            title={
                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                    {title ? t(title) : t('select')}
                </div>
            }
            destroyOnHidden
            onCancel={toggle}
            open={isToggle}
            footer={null}>
            <div className="flex flex-col">
                {
                    !!description && (
                        <div className="flex flex-col gap-1">
                            <span className="text-doc-sm text-color-200 italic tracking-wider">
                                {t(description)}
                            </span>
                        </div>
                    )
                }
                <Input
                    ref={inputSearchRef}
                    onPressEnter={(e) => {
                        onFinish(createValue(type, searchTerm || ''))
                        toggle()
                    }}
                    autoFocus={true}
                    onChange={(e) => {
                        preventParentEvent(e)
                        if (e && e.target && e.target.value) {
                            setSearchTerm(e.target.value)
                        } else {
                            setSearchTerm('')
                        }
                    }}
                    defaultValue={defaultDisplayValue}
                    placeholder={t('enter your keyword')}
                    allowClear
                    className="rounded-md"
                    prefix={<BsSearch size={12} className="text-color-500 mr-1"/>}
                />
                <Pure
                    key={debouncedSearchTerm}
                    input={[debouncedSearchTerm, selectedOption]}>
                    <LookupResult
                        type={type}
                        createIfNotExists={createIfNotExists}
                        withAlias={withAlias}
                        keyword={debouncedSearchTerm}
                        toggle={toggle}
                        onFinish={onFinish}
                        apiPath={apiPath}
                        selectedOption={selectedOption}
                        defaultDisplayValue={defaultDisplayValue}
                        {...props}
                    />
                </Pure>
                <div className="flex justify-end p-3 mt-6 md:mt-8">
            <span onClick={toggle}
                  className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                {t('close')}
            </span>
                </div>
            </div>
        </Modal>
    )
}

export const LookupComponent = ({
                                    name,
                                    defaultValue,
                                    isLoading = false,
                                    createIfNotExists = true,
                                    handleChange,
                                    apiPath = null,
                                    title,
                                    description,
                                    renderActionButton,
                                    isLoginRequired = false,
                                    ...props
                                }) => {
    const t = useTranslate()
    const handleRequiredLogin = useRequiredLogin()

    const [isToggle, toggle] = useToggle(false)

    if (isToggle) {
        return (
            <React.Fragment>
                <div className="px-1 py-3 text-color-400 italic">
                    {t('selecting...')}
                </div>
                <Lookup
                    title={title}
                    description={description}
                    type={name}
                    isToggle={isToggle}
                    toggle={toggle}
                    selectedOption={defaultValue}
                    createIfNotExists={createIfNotExists}
                    onFinish={handleChange}
                    apiPath={apiPath}
                    {...props}
                />
            </React.Fragment>
        )
    }

    if (isLoading) {
        return <LoadingBlock/>
    }

    return (
        <div
            onClick={() => {
                if (!!isLoginRequired) {
                    handleRequiredLogin(() => {
                        toggle()
                    })
                } else {
                    toggle()
                }
            }}>
            {renderActionButton ? (
                renderActionButton()
            ) : (
                <Icon component={AiOutlineQuestion}/>
            )}
        </div>
    )
}

const LookupField = ({
                         search = true,
                         name,
                         bordered,
                         defaultValue,
                         selectedOption,
                         disabled = false,
                         createIfNotExists = true,
                         withAlias = false,
                         placeholder,
                         handleChange,
                         apiPath = null,
                         renderEnterButton,
                         getValue = renderSelf,
                         title,
                         className,
                         withInput = (values) => ({}),
                         ...props
                     }) => {
    const t = useTranslate()
    // const isClearingRef = useRef(false);
    const [isToggle, toggle] = useToggle(false)

    if (isToggle) {
        return (
            <React.Fragment>
                <div className="px-3 py-1 flex-1 border border-color-50 rounded-lg text-color-400 italic">
                    {t('selecting...')}
                </div>
                <Lookup
                    title={title}
                    type={name}
                    isToggle={isToggle}
                    toggle={toggle}
                    withAlias={withAlias}
                    selectedOption={selectedOption}
                    createIfNotExists={createIfNotExists}
                    onFinish={handleChange}
                    apiPath={apiPath}
                    defaultDisplayValue={defaultValue}
                    {...props}
                />
            </React.Fragment>
        )
    }

    return (search ? (
            <Input
                onFocus={() => {
                    toggle(true);
                }}
                value={getValue(defaultValue)}
                disabled={disabled}
                className={classNames('w-full rounded-md', className)}
                prefix={!!selectedOption?.id ? <PiLink className="text-blue-500"/> :
                    <RxKeyboard className="text-color-400"/>}
                placeholder={!!placeholder ? t(placeholder) : t(createIfNotExists ? 'click to select / create' : 'click to select')}
                suffix={
                    renderEnterButton ? (
                        renderEnterButton(toggle, () => handleChange(createValue(name, null)))
                    ) : (
                        renderIfElse(
                            defaultValue,
                            <IoClose
                                size={14}
                                onClick={() => handleChange(createValue(name, null))}
                                className="text-color-400 hover:text-color-100 cursor-pointer"
                            />,
                            <RiSearch2Line size={12} className="text-color-500"/>
                        )
                    )
                }
                // onSearch={(value, event) => {
                //     handleChange(createValue(name, null))
                // }}
                {...(withInput({toggle, isToggle}) ?? {})}
            />) : (
            <Input
                value={getValue(defaultValue)}
                disabled={disabled}
                // onClear={() => {
                //     isClearingRef.current = true;
                //
                // }}
                onFocus={() => {
                    // setTimeout(() => {
                    //     if (isClearingRef.current) {
                    //         isClearingRef.current = false;
                    //         return;
                    //     }
                    //     toggle(true);
                    // }, 300)
                    toggle(true);

                }}
                className={classNames('w-full rounded-md')}
                prefix={!!selectedOption?.id ? <PiLinkLight/> : <PiLinkBreakLight/>}
                placeholder={!!placeholder ? t(placeholder) : t(createIfNotExists ? 'click to select / create' : 'click to select')}
                suffix={
                    renderIfElse(
                        defaultValue,
                        <IoClose
                            size={14}
                            onClick={() => handleChange(createValue(name, null))}
                            className="text-color-400 hover:text-color-100 cursor-pointer"
                        />,
                        <BsCaretDownFill size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    )
                }
                // onSearch={(value, event) => {
                //     handleChange(createValue(name, null))
                // }}
            />
        )
    )
}

export const useLookupField = ({
                                   name,
                                   title,
                                   handleChange,
                                   defaultValue,
                                   apiPath = null,
                                   createIfNotExists = true,
                                   ...props
                               }) => {
    const [isToggle, toggle] = useToggle(false)
    return {
        toggle,
        isToggle,
        modal: (
            <Lookup
                type={name}
                title={title}
                toggle={toggle}
                apiPath={apiPath}
                isToggle={isToggle}
                onFinish={handleChange}
                selectedOption={defaultValue}
                createIfNotExists={createIfNotExists}
                {...props}
            />
        ),
    }
}

export default LookupField
